// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1351":"617c43df","2642":"617c43df","2894":"617c43df","3075":"d978c786","3587":"617c43df","6907":"617c43df","7628":"617c43df"}[chunkId] + ".chunk.css";
};